// extracted by mini-css-extract-plugin
export default {"infoItem":"Document_infoItem__kIOIV"};